module.exports = __webpack_public_path__ + "tooltip1.410969661a19142e0beb.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/images/tooltip/tooltip1.svg
// module id = ../../../../../theme/images/tooltip/tooltip1.svg
// module chunks = styles